import { render, staticRenderFns } from "./IpsButton.vue?vue&type=template&id=3fdc6772&scoped=true"
import script from "./IpsButton.vue?vue&type=script&lang=js"
export * from "./IpsButton.vue?vue&type=script&lang=js"
import style0 from "./IpsButton.vue?vue&type=style&index=0&id=3fdc6772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc6772",
  null
  
)

export default component.exports